import React from "react";

const HeaderSubPageTiny = ({title, subtitle}) => {
    return (
        <div className="top_site_main_tiny">
        </div>
    )
}

export default HeaderSubPageTiny